module.exports = __webpack_public_path__ + "img/empty.b33f89c3.png";